import styled, { css } from 'foundations-theming/utils';
import { TwoWayTransition } from '../../components/TwoWayTransition';
import { ModalTransitionContextProvider } from './ModalTransitionContext';
import { StyledDialog } from '../Dialog/Dialog';
import { PlainWrapper } from '../TwoWayTransition/TwoWayTransition';
import { StyledOverlayElement } from '../Overlay/Overlay';
import { DEFAULT_MODAL_TRANSITION_TIMING, MODAL_BACKGROUND_TRANSITION_TIMING } from '../../../constants/times';
import { jsx as _jsx } from "react/jsx-runtime";
export const getOverlayTransition = dialogTransitionTime => css(["", "{transition-property:", ";transition-delay:", "ms;transition-duration:", ";background-color:", ";}"], StyledOverlayElement, ({
  transitioning
}) => transitioning ? 'background-color' : 'none', ({
  open
}) => open ? 0 : dialogTransitionTime, MODAL_BACKGROUND_TRANSITION_TIMING, ({
  open
}) => `rgba(45, 62, 80, ${open ? '0.79' : '0'})`);
const totalTransitionTime = parseInt(DEFAULT_MODAL_TRANSITION_TIMING, 10);
const overlayTransitionTime = parseInt(MODAL_BACKGROUND_TRANSITION_TIMING, 10);
const dialogTransitionTime = totalTransitionTime - overlayTransitionTime;
const overlayTransition = getOverlayTransition(dialogTransitionTime);
const ModalTransitionWrapper = styled(PlainWrapper).withConfig({
  displayName: "ModalTransition__ModalTransitionWrapper",
  componentId: "z8yfk-0"
})(["", "{transition-property:", ";transition-delay:", "ms;transition-duration:", "ms;opacity:", ";transform:", ";}", ";"], StyledDialog, ({
  transitionActive
}) => transitionActive ? 'opacity, transform' : 'none', overlayTransitionTime, dialogTransitionTime, ({
  open
}) => open ? '1' : '0', ({
  open
}) => `scale(${open ? '1' : '0.9'})`, overlayTransition);
export const ModalTransition = props => /*#__PURE__*/_jsx(TwoWayTransition, Object.assign({}, props, {
  ContextProvider: ModalTransitionContextProvider,
  duration: totalTransitionTime,
  transitionOnMount: true,
  Wrapper: ModalTransitionWrapper
}));